import { PropsWithChildren } from 'react';
import {
  FontLoader,
  ThemeProvider as YogaThemeProvider,
  v3theme,
} from '@gympass/yoga';

import GlobalStyles from 'styles/GlobalStyles';

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <YogaThemeProvider theme={v3theme}>
      <GlobalStyles />
      <FontLoader />
      {children}
    </YogaThemeProvider>
  );
}
